import {lazy} from "react";
import {createBrowserRouter} from "react-router-dom";
import RootLayout from "./layout/rootLayout";

// Lazy-load route components for code splitting
const Home = lazy(() => import("./Pages/Home"));
const Request = lazy(() => import("./Pages/Request"));
const Vendor = lazy(() => import("./Pages/Vendor"));
const About = lazy(() => import("./Pages/About"));
const PageNotFound = lazy(() => import("./Pages/PageNotFound"));

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "/request",
        element: <Request />,
      },
      {
        path: "/about",
        element: <About />,
      },
      {
        path: "/vendor/:vendor",
        element: <Vendor />,
      },
      {
        path: "*",
        element: <PageNotFound />,
      },
    ],
  },
]);
